<form [formGroup]="formControlAddress">
    <div>
        <mat-form-field appearance="outline" class="medium-input-grid">
            <mat-label>{{'cep.cep' | translate}}</mat-label>
            <input matInput formControlName="cep" maxlength="9" data-test="campo-cep"
                (blur)="onCepBlurOrEnter()" (keydown.enter)="onCepBlurOrEnter()">
            <mat-spinner matSuffix diameter="18" *ngIf="buscandoCep"></mat-spinner>
            <mat-error *ngIf="formControlAddress.controls['cep']">
                {{messageError.errorMessage(formControlAddress.controls['cep'])}}
            </mat-error>
        </mat-form-field>
    </div>
        <mat-form-field appearance="outline" class="full-input-grid">
            <mat-label>{{'cep.address' | translate}}</mat-label>
            <input matInput formControlName="address" data-test="campo-endereco">
            <mat-error *ngIf="formControlAddress.controls['address']">
                {{messageError.errorMessage(formControlAddress.controls['address'])}}
            </mat-error>
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="medium-input-grid">
            <mat-label>{{'cep.district' | translate}}</mat-label>
            <input matInput formControlName="district" data-test="campo-bairro">
            <mat-error *ngIf="formControlAddress.controls['district']">
                {{messageError.errorMessage(formControlAddress.controls['district'])}}
            </mat-error>
        </mat-form-field>

    <mat-form-field appearance="outline" class="medium-input-grid default-left-margin-input-field">
        <mat-label>{{'cep.number' | translate}}</mat-label>
        <input #numberInput type="text" matInput formControlName="number" maxlength="10" data-test="campo-numero-endereco">
        <mat-error *ngIf="formControlAddress.controls['number']">
            {{messageError.errorMessage(formControlAddress.controls['number'])}}
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-input-grid">
        <mat-label>{{'cep.complement' | translate}}</mat-label>
        <input matInput formControlName="complement" maxlength="251" data-test="campo-complemento">
        <mat-error *ngIf="formControlAddress.controls['complement']">
            {{messageError.errorMessage(formControlAddress.controls['complement'])}}
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="medium-input-grid">
        <mat-label>{{'cep.city' | translate}}</mat-label>
        <input matInput formControlName="city" data-test="campo-cidade">
        <mat-error *ngIf="formControlAddress.controls['city']">
            {{messageError.errorMessage(formControlAddress.controls['city'])}}
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="medium-input-grid default-left-margin-input-field">
        <mat-label>{{'cep.state' | translate}}</mat-label>
        <input type="text" matInput formControlName="state" maxlength="2" data-test="campo-uf" (blur)="validateUf()">
        <mat-error *ngIf="formControlAddress.controls['state']">
            {{messageError.errorMessage(formControlAddress.controls['state'])}}
        </mat-error>
    </mat-form-field>
</form>